import * as React from "react";
import { WizardHotelPWAFlexComponent } from "../typings";
import { UitkCheckbox } from "uitk-react-switch";
import { locKeys } from "./l10n";
import { useLocalization } from "@shared-ui/localization-context";

export const AddFlight = ({
  flexComponent,
  changeFormProperties,
  isFlightAdded,
  disablePackageOptions
}: {
  flexComponent: WizardHotelPWAFlexComponent;
  isFlightAdded: boolean;
  changeFormProperties: (event: React.ChangeEvent<HTMLFormElement>) => void;
  disablePackageOptions?: boolean;
}) => {
  if (!flexComponent.model.enableAddFlight) {
    return null;
  }

  const { formatText } = useLocalization();

  return (
    <div className="packageCheckbox all-r-padding-three">
      <UitkCheckbox
        id="addFlight"
        label={formatText(locKeys.addFlightLabel)}
        checked={isFlightAdded}
        onChange={changeFormProperties}
        disabled={disablePackageOptions}
      />
    </div>
  );
};
